export default __webpack_public_path__ + "static/media/timer.4109d22f.svg";